"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { useChains } from "@opensea/app-kit";
import { Avatar, Dropdown, DropdownItem, DropdownItemContent, DropdownItemTitle, Item, ItemAvatar, ItemContent, ItemTitle } from "@opensea/next-ui-kit";
import { BottomSheet, BottomSheetBody, classNames, Flex, Media, SwitchPill, Tooltip, useIsLessThanMd } from "@opensea/ui-kit";
import { MoreHoriz } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
export function ExpandedSearchChainFilter(t0) {
  const $ = _c(34);
  const {
    chainType: t1,
    category,
    value,
    onSelectChainAction,
    className
  } = t0;
  const chainType = t1 === undefined ? "all" : t1;
  const t = useTranslations("ExpandedSearchChainFilter");
  const {
    chains,
    evmChains,
    getLogo,
    isChainCurrencyOnly
  } = useChains();
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const isLessThanMd = useIsLessThanMd();
  const visibleChainIndex = isLessThanMd ? 5 : 8;
  let t2;
  if ($[0] !== category) {
    t2 = function getPriorityChains() {
      switch (category) {
        case "collections":
          {
            return ["ethereum", "abstract", "bera_chain", "base", "ronin", "polygon", "ape_chain", "arbitrum"];
          }
        case "items":
          {
            return ["ethereum", "abstract", "bera_chain", "base", "ronin", "polygon", "ape_chain", "arbitrum"];
          }
        case "tokens":
          {
            return ["ethereum", "solana", "abstract", "bera_chain", "base", "polygon", "arbitrum", "avalanche"];
          }
        default:
          {
            return ["ethereum", "solana", "abstract", "bera_chain", "base", "ronin", "polygon", "ape_chain"];
          }
      }
    };
    $[0] = category;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getPriorityChains = t2;
  let t3;
  if ($[2] !== getPriorityChains) {
    t3 = getPriorityChains();
    $[2] = getPriorityChains;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const priorityChains = t3;
  let t4;
  if ($[4] !== chainType || $[5] !== chains || $[6] !== evmChains || $[7] !== isChainCurrencyOnly) {
    t4 = function getAllChains() {
      switch (chainType) {
        case "evm":
          {
            return evmChains;
          }
        case "currency-only":
          {
            return chains.filter(chain => isChainCurrencyOnly(chain.identifier));
          }
        default:
          {
            return chains;
          }
      }
    };
    $[4] = chainType;
    $[5] = chains;
    $[6] = evmChains;
    $[7] = isChainCurrencyOnly;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const getAllChains = t4;
  let t5;
  if ($[9] !== category || $[10] !== className || $[11] !== getAllChains || $[12] !== getLogo || $[13] !== isSheetOpen || $[14] !== onSelectChainAction || $[15] !== priorityChains || $[16] !== t || $[17] !== value || $[18] !== visibleChainIndex) {
    const allChains = getAllChains();
    const getSortedChains = function getSortedChains() {
      const priority = allChains.filter(chain_0 => priorityChains.includes(chain_0.identifier));
      const others = allChains.filter(chain_1 => !priorityChains.includes(chain_1.identifier));
      priority.sort((a, b) => {
        const aIndex = priorityChains.indexOf(a.identifier);
        const bIndex = priorityChains.indexOf(b.identifier);
        return aIndex - bIndex;
      });
      others.sort(_temp);
      return [...priority, ...others];
    };
    const sortedChains = getSortedChains();
    const selectedChain = sortedChains.find(chain_2 => chain_2.identifier === value);
    let finalChains = [...sortedChains];
    if (selectedChain) {
      const selectedChainIndex = finalChains.findIndex(chain_3 => chain_3.identifier === selectedChain.identifier);
      if (selectedChainIndex >= visibleChainIndex) {
        finalChains = finalChains.filter(chain_4 => chain_4.identifier !== selectedChain.identifier);
        finalChains.splice(visibleChainIndex - 1, 0, selectedChain);
      }
    }
    const visibleChains = finalChains.slice(0, visibleChainIndex);
    const dropdownChains = finalChains.slice(visibleChainIndex);
    const isAllSelected = value === "all";
    let t6;
    if ($[20] !== category || $[21] !== onSelectChainAction || $[22] !== value) {
      t6 = chain_5 => {
        track("Search Filter Applied", {
          filter_type: "chain",
          chain_selected: chain_5,
          previous_chain: value,
          category
        });
        onSelectChainAction(chain_5);
      };
      $[20] = category;
      $[21] = onSelectChainAction;
      $[22] = value;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    const handleChainSelection = t6;
    let t7;
    if ($[24] !== className) {
      t7 = classNames("gap-2 px-4", className);
      $[24] = className;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    let t8;
    if ($[26] !== handleChainSelection) {
      t8 = () => handleChainSelection("all");
      $[26] = handleChainSelection;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    let t9;
    if ($[28] !== t) {
      t9 = t("all");
      $[28] = t;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    let t10;
    if ($[30] !== isAllSelected || $[31] !== t8 || $[32] !== t9) {
      t10 = <SwitchPill checked={isAllSelected} className="h-9 grow rounded-md font-medium text-sm" onClick={t8} value="all">{t9}</SwitchPill>;
      $[30] = isAllSelected;
      $[31] = t8;
      $[32] = t9;
      $[33] = t10;
    } else {
      t10 = $[33];
    }
    t5 = <Flex className={t7}>{t10}{visibleChains.map(chain_6 => <Tooltip content={chain_6.name} key={chain_6.identifier}><span className="grow"><SwitchPill checked={value === chain_6.identifier} className="h-9 w-full rounded-md" key={chain_6.identifier} onClick={() => handleChainSelection(chain_6.identifier)} value={chain_6.identifier}><div className={classNames("relative inset-shadow-border size-[18px] rounded-full")}>{" "}<Avatar {...getLogo(chain_6.identifier, {
                circle: true
              })} size={18} />{" "}</div></SwitchPill></span></Tooltip>)}{dropdownChains.length > 0 ? <><Media greaterThanOrEqual="md"><Dropdown align="end" content={dropdownChains.map(chain_7 => <DropdownItem key={chain_7.identifier} onClick={e => {
            e.stopPropagation();
            handleChainSelection(chain_7.identifier);
          }}><Avatar {...getLogo(chain_7.identifier, {
              circle: true
            })} size={16} /><DropdownItemContent><DropdownItemTitle>{chain_7.name}</DropdownItemTitle></DropdownItemContent></DropdownItem>)} overrides={{
            Content: {
              className: "z-[9999]"
            }
          }}><SwitchPill className="h-9 grow rounded-md"><MoreHoriz size={20} /></SwitchPill></Dropdown></Media><Media lessThan="md"><BottomSheet className="z-[9999]" content={<BottomSheetBody className="py-2">{dropdownChains.map(chain_8 => <Item className="py-2" key={chain_8.identifier} onClick={e_0 => {
              e_0.stopPropagation();
              handleChainSelection(chain_8.identifier);
              setIsSheetOpen(false);
            }} variant="unstyled"><ItemAvatar {...getLogo(chain_8.identifier, {
                circle: true
              })} /><ItemContent><ItemTitle>{chain_8.name}</ItemTitle></ItemContent></Item>)}</BottomSheetBody>} nested={true} onOpenChange={setIsSheetOpen} open={isSheetOpen}><SwitchPill className="h-9 grow rounded-md"><MoreHoriz size={20} /></SwitchPill></BottomSheet></Media></> : null}</Flex>;
    $[9] = category;
    $[10] = className;
    $[11] = getAllChains;
    $[12] = getLogo;
    $[13] = isSheetOpen;
    $[14] = onSelectChainAction;
    $[15] = priorityChains;
    $[16] = t;
    $[17] = value;
    $[18] = visibleChainIndex;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function _temp(a_0, b_0) {
  return a_0.name.localeCompare(b_0.name);
}